/* eslint-disable consistent-return */
import React, { useEffect } from "react";
import {
  RootStore,
  useAppDispatch,
  useAppSelector,
} from "../../../../store/store";
import { roles } from "../../../../helpers/utils/Constants/roles";
import {
  getFilterdSprintByPathId,
  getLearningPathForSprintFilter,
  getOnBoarding,
  updateSelectedLearningPath,
} from "../../../../store/features/UserDashboard/NewUserDashboard/NewUserDashoardApi";
import { getRoleValue } from "../VideoTourCard/getSlugByUserrole";
import { LOCAL_STORAGE_KEYS } from "../../../../helpers/utils/Constants/keys";
import { SELF_PACED_ROLES } from "../../../../helpers/utils/Constants/course";

const BannerText = () => {
  const authState: any = useAppSelector((store: RootStore) => store.AuthSlice);
  const dashState: any = useAppSelector(
    (store: RootStore) => store.NewDashboard
  );
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(getLearningPathForSprintFilter({ type: "self" }));
    dispatch(
      getOnBoarding({
        page: getRoleValue(authState?.tac_user?.role, authState),
      })
    );
  }, [dispatch]);

  // get selected course from localstroge
  const getSelectedCourseId = () => {
    const selectedCourse = localStorage.getItem(LOCAL_STORAGE_KEYS.USER_TYPE);

    const courseWithPathId = SELF_PACED_ROLES.find(
      (c) => c.value === selectedCourse
    );

    // console.log("courseWithPathId::", courseWithPathId);

    const courseWithId = dashState.learning_path_for_filter.find(
      (c: any) => c.path_id === courseWithPathId?.path_id
    );
    if (courseWithId) {
      return courseWithId?.id;
    }

    const authRole = authState?.tac_user?.role;
    const roles = SELF_PACED_ROLES.find((r) => r.value === authRole);
    const courseWithIds = dashState.learning_path_for_filter.find(
      (c: any) => c.path_id === roles?.path_id
    );
    if (courseWithIds) {
      return courseWithIds?.id;
    }
  };

  const getFreeSelectedCourseId = () => {
    let path_id: number | null = null;
    if (
      authState.tac_user.all_roles.includes(
        roles.FREE_SELF_PACED_BUSINESS_ANALYST_STUDENT
      )
    ) {
      path_id = 299114;
    }
    if (
      authState.tac_user.all_roles.includes(
        roles.FREE_SELF_PACED_PRODUCT_OWNER_STUDENT
      )
    ) {
      path_id = 299116;
    }

    const courseWithId = dashState.learning_path_for_filter.find(
      (c: any) => c.path_id === path_id
    );

    return courseWithId?.id;
  };

  useEffect(() => {
    if (
      dashState.req_success.get_path &&
      dashState.learning_path_for_filter.length > 0
    ) {
      const courseId = getSelectedCourseId();

      if (courseId) {
        dispatch(getFilterdSprintByPathId({ id: courseId }));
      }

      const freeCourseId = getFreeSelectedCourseId();
      // console.log("freeCourseId::", freeCourseId);

      if (freeCourseId) {
        dispatch(getFilterdSprintByPathId({ id: freeCourseId }));
      }
    }
  }, [
    dashState.req_success.get_path,
    dashState.learning_path_for_filter,
    dispatch,
  ]);

  // console.log(dashState)
  const roleNames = {
    [roles.SELF_PACED_PRODUCT_MANAGER_STUDENT]: "Self-Paced Product Manager",
    [roles.SELF_PACED_SCRUM_MASTER_STUDENT]: "Self-Paced Scrum Master",
    [roles.SELF_PACED_PRODUCT_OWNER_STUDENT]: "Self-Paced AI Product Owner",
    [roles.SELF_PACED_BUSINESS_ANALYST_STUDENT]: "Self-Paced Business Analyst",
    [roles.SELF_PACED_AGILE_PROJECT_MANAGER_STUDENT]:
      "Self-Paced Agile Project Manager",
    [roles.AI_BUSINESS_ANALYST_STUDENT]: "AI Business Analyst",
  };

  const getFreeRolesName = () => {
    if (
      authState.tac_user.all_roles.includes(
        roles.FREE_SELF_PACED_BUSINESS_ANALYST_STUDENT
      )
    ) {
      return "Free Self Paced Business Analyst";
    }
    if (
      authState.tac_user.all_roles.includes(
        roles.FREE_SELF_PACED_PRODUCT_OWNER_STUDENT
      )
    ) {
      return "Free Self Paced Product Owner";
    }
  };

  const getRoleTitle = () => {
    // const allRoles: string[] = authState?.tac_user?.all_roles || [];
    const role = localStorage.getItem(LOCAL_STORAGE_KEYS.USER_TYPE);

    // 1️⃣ Check self paced roles
    const selfRole = SELF_PACED_ROLES.find((r) => r.value === role);
    if (selfRole) return selfRole.name;

    // check roles from authState
    const authRole = authState?.tac_user?.role;
    const roles = SELF_PACED_ROLES.find((r) => r.value === authRole);
    if (roles) return roles.name;

    // for free roles
    const freeRole = getFreeRolesName();
    if (freeRole) return freeRole;

    return "Unknown";
  };

  return (
    <div className="text__and__select__section">
      <span className="welcome__text">
        Welcome, {authState?.tac_user?.first_name}!
      </span>

      <div className="text__wrapper">
        <p>
          You are on
          <span> {getRoleTitle()} </span>
          track.
        </p>
      </div>
    </div>
  );
};

export default BannerText;
